module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAMAAACtdX32AAAAeFBMVEUetTogtjoktjkmtzgptzgqtjgutjgyuDc0uDY0uDc7uTU+uTVCujRNuzJQuzJSuzFSuzJWvDFbvTBcvTBzwCx7wSuJwimJwyiMwyikxiSuxyK8ySHIyx/VzBzdzRvizRrwzxj10Bf20Bf30Bf40Bf60Bb70Rb80RZVJfOcAAAAc0lEQVQYGd3BSQ6CMABA0c9QUGaQKvMk0vvfUGKMi9K4dOF7/ND5xDe3K2YO4LXbo/UAB13CTtwXwS5BJ33gkmYF4Et0ueRD5ujcKeAtmFwO6j7iJeprjsQ4V7Ftx9U8CgzCTql1VaoLMbLKZhia0uIfPAHKDwWJhwBecgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/mr.png
// module id = 887
// module chunks = 0